export enum MaterialType {
  STANDARD = "standard",
  BASIC = "basic",
  SHADER = "shader",
  PHONG = "phong",
}
